<template>
  <div>
    <h5>
      {{ "download_doc_step_1" | setText("1. Скачать договор") }}

      <div class="mt-2">
        <a :href="doc" target="_blank" class="btn btn-info btn-sm mr-2"
          >скачать (RU)</a
        >
        <a
          :href="`${doc}?localization=uz`"
          target="_blank"
          class="btn btn-info btn-sm"
          >скачать (UZ)</a
        >
      </div>
    </h5>
    <h5 class="mb-3">
      {{ "print_step_2" | setText("2. Распечатать в 2-ух экземплярах") }}
    </h5>
    <h5 class="mb-3">
      {{ "sign_step_3" | setText("3. Клиент должен подписать") }}
    </h5>
    <h5 class="mb-3">
      {{ "photo_step_4" | setText("4. Сфотографировать подписанный договор") }}
    </h5>
    <hr />
    <h5>
      {{ "upload_step_4" | setText("6. Загрузить договор в систему") }}
    </h5>
    <input @change="apply" class="btn btn-info" type="file" />
    <br />
    <br />
    <h5 v-if="sign" class="text-success">
      <div class="">
        <a :href="sign" target="_blank" class="btn btn-warning mw">{{
          "download" | setText("скачать")
        }}</a>
      </div>
    </h5>
  </div>
</template>

<script>
export default {
  props: {
    sign: {
      default: null,
    },
    doc: {
      default: "",
    },
  },
  methods: {
    async apply(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.$emit("input", file);
      }
    },
  },
  data() {
    return {};
  },
};
</script>